import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent } from 'vue';
import { PlayerIcon } from '@/enums/player-icon';

import VideoPlayerWrapper from '@/ui-components/VideoPlayerWrapper.vue';
import { TrailerClip } from '@/interfaces/trailerClip';
import { Clip } from '@/@types/graphql-types';

import Spinner from '@/ui-components/Spinner.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext } from '@/helpers/tracking/providers';

interface DailyMotionPlayerProps {
	clip: TrailerClip | Clip;
	title?: TitleDetail;
	isActive?: boolean;
	isBackdrop?: boolean;
	playIconType?: PlayerIcon | null;
	isDisneyPlusOffer?: boolean;
	isTitleTrailer?: boolean;
	additionalContexts?: SnowplowContext[];
	hideTrailerAd?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyMotionPlayer',
  props: {
    clip: null,
    title: null,
    isActive: { type: Boolean, default: false },
    isBackdrop: { type: Boolean, default: false },
    playIconType: { default: null },
    isDisneyPlusOffer: { type: Boolean, default: false },
    isTitleTrailer: { type: Boolean },
    additionalContexts: null,
    hideTrailerAd: { type: Boolean, default: false }
  },
  emits: ["setActiveClipId", "onPlaying"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'setActiveClipId', clipId: string): void;
	(e: 'onPlaying', clip: DailyMotionPlayerProps['clip']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { clip: TrailerClip | Clip, title?: TitleDetail, isActive: boolean, isBackdrop: boolean, playIconType: PlayerIcon | null, isDisneyPlusOffer: boolean, isTitleTrailer?: boolean, additionalContexts?: SnowplowContext[], hideTrailerAd: boolean };

const SelfHostedTrailerPlayer = defineAsyncComponent({
	loader: () => import(/* webpackChunkName: "self-hosted-trailer-player" */ './SelfHostedTrailerPlayer.vue'),
	loadingComponent: Spinner,
});





const playerIdsByType = {
	DEFAULT_TRAILERS: 'xb9cu',
	NO_ADS_TRAILERS: 'x1dwv8',
};

const hasDynamicManifest = computed(() => !!(props.clip as any).sources?.dynamicManifest?.fileGroupId);
const isBitMovinVideo = computed(() => {
	return (
		hasDynamicManifest.value ||
		props.clip.sourceUrl?.includes('dailymotion.com/cdn/manifest') ||
		props.clip.externalId === 'b2Z8dG04Nzg3MjpERTpqd3Q6ZnJlZTpoZA=='
	);
});

const playerId = computed(() => {
	if (props.hideTrailerAd) {
		return playerIdsByType['NO_ADS_TRAILERS'];
	}
	return playerIdsByType['DEFAULT_TRAILERS'];
});

const srcUrl = computed(() => {
	if (props.clip.sourceUrl && !props.hideTrailerAd) return props.clip.sourceUrl;
	return `https://geo.dailymotion.com/player/${playerId.value}.html?video=${props.clip.externalId}`;
});

function play() {
	emit('setActiveClipId', props.clip.externalId);

	// onPlaying triggers scrolling to active clip. setTimeout prevents onPlaying triggering scroll events before activeClip is updated
	setTimeout(() => {
		emit('onPlaying', props.clip);
	}, 200);
}

return { __sfc: true,SelfHostedTrailerPlayer, props, emit, playerIdsByType, hasDynamicManifest, isBitMovinVideo, playerId, srcUrl, play, VideoPlayerWrapper }
}

})